// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// import VueI18n from 'vue-i18n'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import store from './store';


// import locale from 'element-ui/lib/locale/lang/en'
import i18n from './lang/index';
import Clipboard from 'v-clipboard'

// import axios from 'axios'
// axios.defaults.baseURL = 'https://intl-uc-api.yisu.com'


// Vue.use(VueI18n)
// Vue.use(ElementUI,{locale})
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})
Vue.use(Clipboard)

import http from './utils/http'
import util from './utils/util'
import api from './utils/api'
Vue.config.productionTip = false

import xss from 'xss';
Vue.prototype.$xss = xss


Vue.prototype.$http = http;
Vue.prototype.$util = util;
Vue.prototype.$api = api;


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js